import { useTranslation } from 'react-i18next';
import MandatoryAsterisk from 'components/common/MandatoryAsterisk';
import MutedText from 'components/common/MutedText';
import HubertCombobox from 'components/HubertUI/HubertCombobox';
import HubertLabel from 'components/HubertUI/HubertLabel';
import type { TVisibility } from 'types/template/template.types';
import type { TSelectBase } from 'types/general.types';

type Props = {
  accessGroupOptions: TSelectBase[];
  isFormDisabled: boolean;
  selectedAccessGroupIds: string[] | undefined;
  onSelectedAccessGroupIdsChange: (value: string[]) => void;
  visibility: TVisibility | undefined;
  hint?: string;
  chosenAccessGroupsLackTemplateCreate?: boolean;
};

export const AccessGroupSettings = ({
  accessGroupOptions,
  isFormDisabled,
  selectedAccessGroupIds,
  onSelectedAccessGroupIdsChange,
  hint,
  chosenAccessGroupsLackTemplateCreate = false,
}: Props) => {
  const { t } = useTranslation('Templates');
  return (
    <div className="flex flex-col gap-2 p-1">
      <HubertLabel htmlFor="create-template-access-group-combobox">
        {t('accessSettings.accessGroup.label')}
        <MandatoryAsterisk />
      </HubertLabel>
      <HubertCombobox
        className="w-full"
        itemName={t('accessSettings.accessGroup.itemName')}
        items={accessGroupOptions}
        value={selectedAccessGroupIds}
        disabled={isFormDisabled}
        onValueChange={(value) => {
          const accessGroupIds = Array.isArray(value) ? value : [value];
          onSelectedAccessGroupIdsChange(accessGroupIds);
        }}
        isMulti={true}
      />
      {chosenAccessGroupsLackTemplateCreate ? (
        <p className="text-xs text-amber-700">{t('accessSettings.accessGroup.needsTemplateCreate')}</p>
      ) : (
        <MutedText text={hint ?? t('accessSettings.accessGroup.hint')} />
      )}
    </div>
  );
};
